module.exports = __webpack_public_path__ + "static/img/mrtx.3b2ab8e1.png";